module.exports = __webpack_public_path__ + "img/about-us-map.032831f2.svg";